import { gql, useQuery } from "@apollo/client";
import { Server } from "../../apollo/types";
import { logger } from "../../datadog/logger";

export enum ScheduleEventType {
  APPOINTMENT = "appointment",
  BUSY = "busy",
  INVOICE = "invoice",
}

export type SchedulingAlertObject = {
  __typename?: "SchedulingAlertObject";
  alertType: string;
  alertLevel: string;
  alertMessage: string;
} | null;

export type GetSchedulingAlertsQueryData = {
  __typename?: "Query";
  schedulingAlerts?: Array<SchedulingAlertObject> | null;
};

export type GetSchedulingAlertsQueryVariables = {
  values: {
    numRecurrences?: number | null;
    patientCustomerId?: string | null;
    recurrenceRule?: string | null;
    recurring?: boolean | null;
    scheduleEventId?: string | null;
    scheduleEventType?: string | null;
    timeEnd?: string | null;
    timeStart?: string | null;
    weeksBetween?: number | null;
  };
};

export const GET_SCHEDULING_ALERTS = gql`
  query GetSchedulingAlerts($values: SchedulingAlertsQueryInput!) {
    schedulingAlerts(values: $values) {
      alertType
      alertLevel
      alertMessage
    }
  }
`;

export function useGetSchedulingAlerts(
  timeStart?: Date,
  timeEnd?: Date,
  patientCustomerId?: string,
  recurring?: boolean,
  numRecurrences?: number,
  weeksBetween?: number,
  scheduleEventId?: string,
  scheduleEventType?: string,
  recurrenceRule?: string,
) {
  return useQuery<
    GetSchedulingAlertsQueryData,
    GetSchedulingAlertsQueryVariables
  >(GET_SCHEDULING_ALERTS, {
    variables: {
      values: {
        timeStart: timeStart?.toISOString(),
        timeEnd: timeEnd?.toISOString(),
        patientCustomerId,
        recurring,
        numRecurrences,
        weeksBetween,
        scheduleEventId,
        scheduleEventType,
        recurrenceRule,
      },
    },
    context: { server: Server.MONOLITH },
    fetchPolicy: "cache-and-network",
    onError: (error) => {
      logger.error(
        "Unable to get scheduling alerts",
        {
          timeStart,
          timeEnd,
          patientCustomerId,
          recurring,
          numRecurrences,
          weeksBetween,
          scheduleEventId,
          scheduleEventType,
          recurrenceRule,
        },
        error,
      );
    },
  });
}
